import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledIconContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  minWidth: 24,
  minHeight: 24,
  paddingRight: '8px',
  '& > svg': {
    width: 24,
    height: 24,
  },
});

